const LOAD_DATA_MASTER_ALL_JOB_DESTINATION         = 'LOAD_DATA_MASTER_ALL_JOB_DESTINATION'
const LOAD_DATA_MASTER_ALL_JOB_DESTINATION_SUCCESS = 'LOAD_DATA_MASTER_ALL_JOB_DESTINATION_SUCCESS'
const LOAD_DATA_MASTER_ALL_JOB_DESTINATION_FAILED  = 'LOAD_DATA_MASTER_ALL_JOB_DESTINATION_FAILED'
const UNMOUNT_DATA_MASTER_ALL_JOB_DESTINATION      = 'UNMOUNT_DATA_MASTER_ALL_JOB_DESTINATION'

const initialState = {
  loading: true,
  meta: null,
  data: null,
  message: null
}

const allJobDestinationReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOAD_DATA_MASTER_ALL_JOB_DESTINATION:
      return {
        ...state,
        loading: true,
        meta: null,
        data: null
      }
    case LOAD_DATA_MASTER_ALL_JOB_DESTINATION_SUCCESS:
      return {
        ...state, 
        loading: false,
        meta: action.payload.meta,
        data: action.payload.data,
        message: 'SUCCESS'
      }
    case LOAD_DATA_MASTER_ALL_JOB_DESTINATION_FAILED:
      return {
        ...state, 
        loading: false,
        meta: null,
        data: null,
        message: 'FAILED'
      }
    case UNMOUNT_DATA_MASTER_ALL_JOB_DESTINATION:
      return { 
        ...state, 
        loading: true,
        data: null
      }
    default:
      return state
  }
}
export default allJobDestinationReducer